<footer id="footer" class="footer">
  <div class="copyright">
    {{lang?.Version}} :{{env.version}} © {{copyright}} :
    <a class="text-reset fw-bold" href="https://www.groupbenefitz.ca/" target="-blank">
      {{lang?.The_GroupBenefitz_Platform_Inc}}</a>
  </div>
</footer>
